<template> 
<div name="schoolapply" >

  <form v-on:submit.prevent="processOutcomes">

  <section class="card">
<savenotice :title="'Lesson Outcomes'" ref="schoolSaveNotice"></savenotice> 

                   <div v-if="errored" class="empty">
                    <p>We are not able to retrieve this information at the moment, please try back later</p>
                  </div>

   <div class="row gtr-uniform">
    <div class="col-12 col-12-xsmall">
                              <table class="course">
                                <thead class="no-border">
                                  <th >School Name</th>
                                  <th style="width: 14%;">Has Unit</th>

                                </thead>
      
                              <tbody>

                                <template v-for="item in orderedConsuls">
                                <tr class="course list-complete-item">
        
                                  <td >{{ item.name }}</td>
    

                                  <td style="width: 14%;" align="center">
                                      <input :id="setChkId(item.id)" type="checkbox" 
                                      @click="checkboxToggle(item.id)"
                                      v-bind:class="containsSchool(item.id)"
                                      :checked="containsSchool(item.id)">
                                <label :for="setChkId(item.id)"></label>
                                  </td>
                             
                                </tr>
                               
                              </template>
  
                              </tbody>
                              <tfoot>

                              </tfoot>
                            </table>

                            <p class="empty" v-if="!componentLoaded">We could not find any data for your given selection.</p>
                          </div>

    </div>
                 


  </section>

        <section class="card action">
 <savenotice :title="'Unit'" ref="saveNoticeBottom" class="left"></savenotice>
                          <button
                                  type="submit"
                                  class="button purplish medium"
                                >
                                  Save School selection
                                </button>             
          </section>

                      

                                         
   </form>

</div>
</template> 

<script>
import { mapGetters } from "vuex";
const dropdown = () => import("@/components/Dropdown.vue");
const savenotice = () => import("@/components/SaveNotice.vue");
import { SchoolService } from "@/services/school.service";

export default {
  name: "schoolapply",
  props: ["course"],
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    componentLoaded() {
      return this.orderedConsuls.length > 0;
    },
    orderedConsuls() {
      return _.orderBy(this.consuls, ["name"]);
    },
    data() {
      return {
        currentTab: 0
      };
    }
  },
  data() {
    return {
      loading: true,
      errored: false,
      selectedCriteria: {},
      consuls: [],
      selectedOutcomes: [],
      criteria: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      var itemId = this.currentUser.schoolID;

      SchoolService.getAll("consuls")
        .then(response => this.buildConsulList(response.data))
        .catch(err => {
          console.log("Consuls " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildConsulList(data) {
      this.consuls = data;
    },
    processOutcomes() {
      var itemId = this.currentUser.schoolID;
      var courseId = this.course.id;

      let payload = this.selectedOutcomes.map(sel => {
        let outcome = this.outcomes.filter(outcome => {
          return outcome.id === sel.id;
        })[0];
        if (outcome !== undefined) {
          return {
            course_id: courseId,
            outcome_identifier: outcome.identifier,
            lessons: sel.lessons
          };
        }
      });

      SchoolService.create("course/" + courseId + "/outcomes", payload)
        .then(response => this.completion(true))
        .catch(err => {
          console.log("Outcome add error " + err);
        });
    },
    completion(val) {
      if (val == true) {
        this.$refs.outcomesSaveNotice.saved();
      } else {
        this.$refs.outcomesSaveNotice.failed();
      }
      window.scrollTo(0, 0);
    },
    cancel() {
      this.completion(false);
    },
    setChkId(schoolId) {
      return "chk_u" + schoolId;
    },
    checkboxToggle(outcomeId, lessonId) {
      let outcome = this.selectedOutcomes.filter(outcome => {
        return outcome.id === outcomeId;
      })[0];
      if (outcome !== undefined) {
        if (outcome.lessons.includes(lessonId)) {
          outcome.lessons.splice(outcome.lessons.indexOf(lessonId), 1);
        } else {
          outcome.lessons.push(lessonId);
        }
      } else {
        this.selectedOutcomes.push({ id: outcomeId, lessons: [lessonId] });
      }
    },
    containsSchool(schoolId) {
      // let school = this.selectedOutcomes.filter(outcome => { return outcome.id === outcomeId })[0]
      // return (outcome !== undefined && outcome.lessons.includes(lessonId)) ? "active" : ""
      return false;
    }
  },
  components: {
    dropdown,
    savenotice
  }
};
</script>


<style scoped>
.off {
  margin-right: 11px;
}

.form-group span {
  font-weight: 400 !important;
}

input[type="checkbox"]:checked + label {
  background: #7fc6a4 !important;
  border-color: #7fc6a4 !important;
}
</style>
